import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ICurrentBoard } from '../../../core/models/current-board.model';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'lynkd-pattern-side-menu-patterns-boards',
    templateUrl: './side-menu-patterns-boards.component.html',
    styleUrls: ['./side-menu-patterns-boards.component.scss']
})
export class SideMenuPatternsBoardsComponent {
    /**
     * The empty and loading strings below branch on this. The template referenced it before it was
     * ever declared on the component, so the ternaries always took the Pattern wording regardless of
     * branding; declared here so the branch actually works.
     */
    public useBrandivioBranding: boolean = environment.useBrandivioBranding;

    @Input()
    public boards$: Observable<Array<ICurrentBoard>>;

    @Output()
    public readonly boardSelected: EventEmitter<{ saveBoard: boolean; boardId: string }> = new EventEmitter<{
        saveBoard: boolean;
        boardId: string;
    }>();

    public selectBoard($event: MouseEvent, boardId: string): void {
        if (($event.target as HTMLAnchorElement).innerText === '...') {
            $event.stopImmediatePropagation();
            $event.preventDefault();
            return;
        }
        const saveBoard: boolean = ($event.currentTarget as HTMLAnchorElement).classList.contains('board-name');
        this.boardSelected.emit({
            saveBoard,
            boardId
        });
    }
}
